<template>
  <div :style="cssVars">
    <div class="wrapper">
      <nav class="d-flex d-md-block" id="sidebar">
        <div class="sidebar-sticky">
          <ul class="nav flex-column d-flex justify-content-center">
            <b-navbar
              class="text-center opieka_skp"
              v-if="program === 'skp' && isDiscountId(635) && currentOs"
            >
              <p v-if="client.DOD.split('').includes('X')" class="text-center">
                Skorzystaj z RABATU 50% na dodatek: Wersja ograniczona. Ważne do
                28.04.2023 r.
              </p>
              <p v-else class="text-center">
                Skorzystaj z RABATU 50% na dodatki: Wersja ograniczona i Wymiana
                danych. Ważne do 28.04.2023 r.
              </p>
            </b-navbar>

            <b-navbar class="text-center opieka_skp" v-if="discount654_655">
              <p class="text-center">
                Ostatnia szansa!<br />
                Zyskaj aż <strong style="color: yellow">40% RABATU</strong
                ><br />
                na Opiekę Serwisową 2024!<br />
                <strong style="color: yellow"
                  >Oferta ważna do 11.10.2024</strong
                >
              </p>
            </b-navbar>

            <b-navbar
              class="text-center opieka_skp"
              v-if="
                discountCloud &&
                (discountCloud.id === 656 || discountCloud.id === 657)
              "
            >
              PROMOCJA!<br />
              Zamów Opiekę na 2024 i
              <strong style="color: yellow">zyskaj ZA DARMO:</strong>
              Opiekę Serwisową aż do końca 2025 roku + usługę online SKP24
              Connect do końca 2024 roku!
            </b-navbar>

            <b-navbar
              class="text-center opieka_skp"
              v-if="
                program === 'skp' &&
                currentOs &&
                cloudNeverHave2024 &&
                new Date().getFullYear() === 2024 &&
                false
              "
            >
              <p class="text-center font-size-16">
                PROMOCJA! Zamów i zyskaj usługę online SKP24 Connect
                <span style="color: white" v-if="isAccountant"
                  >pakiet EXTRA</span
                ><br />
                <span style="color: #ffd04b"> za 0 zł do końca 2024!</span>
              </p>
            </b-navbar>

            <b-navbar class="text-center opieka_skp" v-if="discount652">
              <p class="text-center">
                Tylko do 25 sierpnia: RABAT 40% na Opiekę Serwisową!
              </p>
            </b-navbar>

            <b-navbar
              class="text-center opieka_skp"
              v-if="!discount25Anniversary && discount641"
            >
              <p class="text-center">
                Odbierz specjalny<br />
                <strong style="color: yellow">RABAT 50 zł</strong> na<br />
                Opiekę Serwisową 2024
              </p>
            </b-navbar>

            <b-navbar
              class="text-center opieka_skp"
              v-if="
                osDiscount &&
                [636, 637, 638].includes(osDiscount.id) &&
                program === 'sam' &&
                !wasTransferredToSkp &&
                new Date().getFullYear() == '2023' &&
                !currentOs
              "
            >
              <p class="text-center">
                <span>
                  Koniec wsparcia i<br />
                  Opieki Serwisowej SAM<sup>®</sup> </span
                ><br />
                Przejdź z SAM<sup>®</sup> na SKP<sup>®</sup><br />
                i obniż o {{ osDiscount.percent }}% cenę<br />
                Opieki Serwisowej 2023
              </p>
            </b-navbar>

            <b-navbar
              class="text-center opieka_skp"
              v-else-if="
                program === 'sam' &&
                new Date().getFullYear() == '2022' &&
                !wasTransferredToSkp
              "
            >
              <p class="text-center">
                Przejdź z {{ program.toUpperCase() }}<sup>®</sup> na SKP<sup
                  >®</sup
                ><br />
                i <span>obniż o 35% cenę</span><br />
                Opieki Serwisowej 2023!<br />
                Oferta ważna do <span>31.12.2022</span>
              </p>
            </b-navbar>

            <b-navbar
              class="black-week-nav text-center"
              v-if="isDiscountId(616)"
            >
              BLACK MONTH<br />
              <span class="black-week-percent">-50%</span>
              <div class="black-week-info black-week-info-os" v-if="!currentOs">
                na Opiekę Serwisową 2024<br />
                + WSZYSTKIE moduły i dodatki
              </div>
              <div class="black-week-info" v-else>
                na WSZYSTKIE<br />
                moduły i dodatki
              </div>
            </b-navbar>

            <b-navbar>
              <img href="#" :src="avatarSrc" alt="skp" class="avatar" />
              <b-navbar-brand tag="h2"> Moje Konto</b-navbar-brand>
            </b-navbar>
            <li class="nav-item active">
              <router-link
                class="nav-link sidebar-item"
                :to="{ name: 'Licence', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <i class="far fa-user"></i>
                  </b-col>
                  <b-col>
                    <span id="test">Dane licencyjne</span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li
              v-if="isTestAccountRegistered || isTestAccountUnregistered"
              class="nav-item"
            >
              <a :href="orderWeb" class="nav-link sidebar-item" target="_blank">
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <i class="fab fa-wpforms"></i>
                  </b-col>
                  <b-col>
                    <span class="text-green text-bold">Zamów SKP</span>
                  </b-col>
                </b-row>
              </a>
            </li>
            <li
              v-if="
                !isTestAccountRegistered &&
                !isTestAccountUnregistered &&
                !wasTransferredToSkp
              "
              class="nav-item"
            >
              <router-link
                :class="{
                  'nav-link': true,
                  'sidebar-item': true,
                  'sidebar-item-two-lines': program === 'sam',
                }"
                :to="{ name: 'Order', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <i class="fab fa-wpforms text-green"></i>
                  </b-col>
                  <b-col class="text-green text-bold">
                    <span class="text-green text-bold" v-if="program === 'sam'"
                      >Bezpłatne przejście na SKP<sup>®</sup> z Opieką Serwisową
                      {{ year }}</span
                    >
                    <span class="text-green text-bold" v-else-if="showOsOrder"
                      >Opieka Serwisowa {{ year }}</span
                    >
                    <span class="text-green text-bold" v-else>Zamówienie</span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li
              v-if="
                !isTestAccountRegistered &&
                !isTestAccountUnregistered &&
                !wasTransferredToSkp
              "
              class="nav-item"
            >
              <router-link
                class="nav-link sidebar-item"
                :to="{ name: 'NewYear', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <i class="fas fa-info"></i>
                  </b-col>
                  <b-col>
                    <span v-if="year == new Date().getFullYear()"
                      >Ostatnie zmiany {{ year }}</span
                    >
                    <span v-else>Co z nowym rokiem? </span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li
              v-if="!isTestAccountRegistered && !isTestAccountUnregistered"
              class="nav-item"
            >
              <router-link
                class="nav-link sidebar-item"
                :to="{ name: 'History', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <i class="fas fa-history"></i>
                  </b-col>
                  <b-col>
                    <span>Historia zamówień</span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li class="nav-item" v-if="!wasTransferredToSkp">
              <router-link
                class="nav-link sidebar-item"
                :to="{ name: 'Messages', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <i class="fas fa-bullhorn"></i>
                  </b-col>
                  <b-col>
                    <span>Wiadomości</span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li class="nav-item" v-if="!wasTransferredToSkp">
              <router-link
                class="nav-link sidebar-item"
                :to="{ name: 'Promotions', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <i class="fas fa-percent"></i>
                  </b-col>
                  <b-col>
                    <span>Promocje</span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li
              v-if="
                !isTestAccountRegistered &&
                !isTestAccountUnregistered &&
                !wasTransferredToSkp
              "
              class="nav-item"
            >
              <router-link
                class="nav-link sidebar-item"
                :to="{ name: 'RecommendAFriend', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <img
                      href="#"
                      :src="styles.dolar"
                      alt="skp"
                      class="img-responsive center-block"
                    />
                  </b-col>
                  <b-col>
                    <span>Poleć znajomemu</span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li
              v-if="
                program === 'skp' &&
                !isLimitedVersion &&
                (!isTestAccountRegistered || !isTestAccountUnregistered)
              "
              class="nav-item"
            >
              <router-link
                class="nav-link sidebar-item"
                :to="{ name: 'Course', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <img
                      href="#"
                      :src="styles.media"
                      alt="skp"
                      class="img-responsive center-block"
                    />
                  </b-col>
                  <b-col>
                    <span>KURS OBSŁUGI SKP<sup>®</sup></span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link sidebar-item"
                :to="{ name: 'Contact', params: { program } }"
              >
                <b-row class="align-items-center">
                  <b-col lg="2" class="text-center pr-0">
                    <i class="far fa-envelope"></i>
                  </b-col>
                  <b-col>
                    <span>Pomoc</span>
                  </b-col>
                </b-row>
              </router-link>
            </li>
            <li
              class="nav-item nav-link sidebar-item checkboxPointer"
              @click.prevent="logout"
            >
              <b-row class="align-items-center">
                <b-col lg="2" class="text-center pr-0">
                  <i class="fas fa-sign-out-alt"></i>
                </b-col>
                <b-col>
                  <span>Wyloguj</span>
                </b-col>
              </b-row>
            </li>
          </ul>
          <div class="logo bg-white">
            <a :href="websiteLink" target="_blank">
              <img
                href="#"
                :src="logoSrc"
                alt="skp"
                class="img-responsive center-block"
            /></a>
          </div>
        </div>
      </nav>
      <div id="content-wrapper" class="d-flex flex-column flex-grow-1">
        <div id="content">
          <div class="container-fluid">
            <b-row class="align-items-center">
              <b-col xl="10">
                <router-view
                  :styles="styles"
                  :checkIcon="styles.check"
                  :checkbox="styles.checkbox"
                  :infoIcon="styles.info"
                  :infoIconFocus="styles.info_focus"
                  :addIcon="styles.add"
                  :xIcon="styles.x"
                ></router-view>
              </b-col>
              <b-col xl="2">
                <banners
                  :styles="styles"
                  :program="program"
                  :hasCourseAccess="hasCourseAccess"
                ></banners>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Banners from './Banners';
import moment from 'moment';
import { sam_plans } from '../config/cloudPlans';

export default {
  name: 'Sidebar',
  components: { Banners },
  data: function () {
    return {
      styles: {},
      currentDiscounts: [],
      year: process.env.MIX_AKTU_YEAR,
      loading: false,
      osOldPrice: {},
      osPrice: {},
      osDiscount: {},
      discountCloud: {},
    };
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      licence: 'auth/userLicence',
      client: 'auth/client',
      program: 'getProgram',
      currentOs: 'auth/currentOs',
      isTestAccountRegistered: 'auth/isTestAccountRegistered',
      isTestAccountUnregistered: 'auth/isTestAccountunRegistered',
      hasCourseAccess: 'auth/hasCourseAccess',
      wasTransferredToSkp: 'auth/wasTransferredToSkp',
      cloudNeverHave2024: 'auth/cloudNeverHave2024',
      discounts: 'order/discounts',
    }),
    cssVars() {
      return {
        '--navbar-color': this.styles.navbarColor,
        '--navbar-yellow-color': this.styles.navbarYellowColor,
        '--navbar-green-color': this.styles.navbarGreenColor,
        '--icons-color': this.styles.iconsColor,
        '--sidebar-color': this.styles.sidebarColor,
        '--headers-color': this.styles.headersColor,
        '--font-color': this.styles.fontColor,
        '--selected-color': this.styles.selectedColor,
        '--info-text-color': this.styles.infoTextColor,
        '--background-color': this.styles.background,
        '--buttons-color': this.styles.buttonsColor,
        '--disabled-color': this.styles.disabledColor,
      };
    },
    logoSrc() {
      return this.styles.logo;
    },
    avatarSrc() {
      return this.styles.avatar;
    },
    websiteLink() {
      if (this.program === 'skp') {
        return 'https://www.ksiega-podatkowa.pl/';
      }

      return 'https://www.samozatrudnienie.pl/';
    },
    orderWeb() {
      let urlWeb = 'https://www.ksiega-podatkowa.pl/zamowienie?';
      if (this.licence == 88888) {
        urlWeb = urlWeb + 'mk-program&';
      }
      if (this.program === 'skp') {
        urlWeb = urlWeb + 'id=' + this.client.orderHash;
      } else {
        urlWeb = urlWeb + 'id=' + this.client.orderHash;
      }
      return urlWeb;
    },
    showOsOrder() {
      return !this.currentOs;
    },
    isLimitedVersion() {
      return (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('O')
      );
    },
    discount641() {
      return (
        this.program == 'skp' &&
        this.client.K == '1' &&
        this.client.M != '1' &&
        this.client.L === 2 &&
        this.osDiscount &&
        this.osDiscount.id === 641
      );
    },
    discount652() {
      return (
        this.program === 'skp' &&
        !this.currentOs &&
        this.client.K == '1' &&
        this.client.M != '1' &&
        [2, 3].includes(this.client.L) &&
        this.osDiscount &&
        this.osDiscount.id === 652
      );
    },
    discount654_655() {
      return (
        this.osDiscount &&
        (this.osDiscount.id === 654 || this.osDiscount.id === 655)
      );
    },
    discount25Anniversary() {
      return (
        this.program == 'skp' &&
        this.client.K == '1' &&
        this.client.M != '1' &&
        [1, 2, 3].includes(this.client.L) &&
        [25].includes(
          moment().format('YYYY') - moment(this.client.SPR).format('YYYY')
        )
      );
    },
    isAccountant() {
      return (
        (this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes('B')) ||
        this.accountantAdd
      );
    },
  },
  created() {
    if (this.isTestAccountUnregistered) {
      window.addEventListener('beforeunload', this.confirmLeaving);
    }
    this.getProgramStyles();
    this.getOsPrice();

    this.$cookies.set('userid', this.licence, '30d');
    this.getCurrentDiscounts();
    axios
      .get('/api/getCloudDiscount/' + this.program + '/' + this.licence)
      .then(({ data }) => {
        if (data) {
          this.discountCloud = data;
        }
      });
  },
  mounted() {
    if (this.authenticated) {
      if (document.body.classList.contains('login')) {
        document.body.classList.remove('login');
      }
    }
  },
  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
    }),
    getMomentDate(date, format) {
      return moment(date).format(format);
    },
    confirmLeaving() {
      this.logout();
    },
    async logout() {
      await this.signOut(this.program);
      await this.$router.push({ name: 'Login' });
    },
    isDiscountId(id) {
      return !!this.currentDiscounts.find((discount) => discount.id === id);
    },
    getCurrentDiscounts() {
      axios.get('/api/currentDiscounts/' + this.program).then(({ data }) => {
        if (data) {
          this.currentDiscounts = Object.values(data);
        }
      });
    },
    getOsPrice() {
      this.loading = true;
      axios
        .get('/api/getOsPrice/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.loading = false;
          this.osOldPrice = data.osOldPrice;
          this.osPrice = data.osPrice;
          this.osDiscount = data.discount;
        });
    },
    getProgramStyles() {
      axios
        .get('/api/getStyles/' + this.program)
        .then((response) => {
          this.styles = response.data;
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 419) {
            this.$store.dispatch('auth/me');
            this.$router.push({ name: 'Login' });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .opieka_skp {
    background-color: #da1b25;
    color: #ffffff;
    padding: 0.5rem;
    font-size: 1.2rem;
    font-weight: bold;
    text-align: center;
    flex-direction: column;

    & span {
      color: rgb(255, 208, 75);
    }

    & span.color-white {
      color: #fff !important;
    }
  }

  .opieka_skp_img {
    text-align: center;
    flex-direction: column;
    padding: 0px;

    & img {
      width: 100%;
      margin: 0px;
      padding: 0px;
    }
  }

  .black-week-nav {
    background: #000;
    color: #da1b25;
    padding: 30px 00px;
    flex-direction: column;
    font-weight: bold;
    font-size: 2em;
  }

  .black-week-percent {
    font-size: 1.4em;
  }

  .black-week-info {
    color: #fff;
  }

  .black-week-info-os {
    font-size: 0.7em;
  }

  .sidebar-item i {
    vertical-align: unset;
  }

  .text-dark-blue {
    color: var(--navbar-color) !important;
  }

  .text-yellow {
    color: var(--navbar-yellow-color) !important;
  }

  .text-green {
    color: var(--navbar-green-color) !important;
  }

  .nav-item {
    .router-link-active {
      .text-green {
        color: #fff !important;
      }

      i {
        color: #fff !important;
      }
    }

    &:hover {
      .text-green {
        color: #fff !important;
      }

      i {
        color: #fff !important;
      }
    }
  }

  .text-bold {
    font-weight: 900 !important;
  }

  @media only screen and (max-width: 1600px) {
    #content {
      .col-xl-2,
      .col-xl-10 {
        width: 100% !important;
        position: relative;
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }
}
</style>
